import './styles.scss'

import React, { useEffect, useRef, useCallback } from 'react'
import { useActions, useValues } from 'kea'
import { useDebouncedCallback } from 'use-debounce'

import BreakOnNewline from 'lib/tags/break-on-newline'
import twicpicsSource from 'lib/utils/twicpics-source'

import Searchbox from '~/scenes/search/search-page/searchbox'
import How from '~/scenes/search/search-page/how'

import startMessageLogic from './logic'

const DEFAULT_COLOR = '#82b841'

const StartMessage = () => {
  const { backgroundLoaded } = useActions(startMessageLogic)
  const { startMessage, loadedImage, isCityOrWebcamActivity } = useValues(startMessageLogic)

  const { h1, h2, coverPhoto, landingPage } = startMessage

  const coverPhotoAreaRef = useRef(null)

  const updatePhoto = useCallback(() => {
    if (typeof window === 'undefined') {
      return
    }

    const imageElement = coverPhotoAreaRef.current

    if (!coverPhoto || !imageElement) {
      return
    }

    const { clientWidth: width, clientHeight: height } = imageElement
    const { w: sourceWidth, h: sourceHeight, fh, fv, url } = coverPhoto

    const sourceAspect = sourceWidth / sourceHeight
    const aspect = width / height

    let rect = ''

    if (sourceAspect > aspect) {
      const y = 0
      const h = sourceHeight
      const w = Math.floor((sourceHeight * width) / height)
      const x = Math.floor(((sourceWidth - w) * fh) / 100)
      rect = `${x},${y},${w},${h}`
    } else if (aspect > sourceAspect) {
      const x = 0
      const w = sourceWidth
      const h = Math.floor((sourceWidth * height) / width)
      const y = Math.floor(((sourceHeight - h) * fv) / 100)
      rect = `${x},${y},${w},${h}`
    }

    const imageUrl = twicpicsSource(url, width, height, 1, rect)

    const img = new window.Image()
    img.onload = () => backgroundLoaded(imageUrl)
    img.src = imageUrl
  }, [backgroundLoaded, coverPhoto])

  const debouncedUpdatePhoto = useDebouncedCallback(updatePhoto, 300)

  useEffect(() => {
    const handleResize = () => {
      backgroundLoaded(null)
      debouncedUpdatePhoto()
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize)
      updatePhoto()
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [debouncedUpdatePhoto, updatePhoto, backgroundLoaded])

  useEffect(() => {
    if (coverPhoto && coverPhoto.url) {
      updatePhoto()
    } else {
      backgroundLoaded(null)
    }
  }, [coverPhoto, updatePhoto, backgroundLoaded])

  const coverPhotoSrc = coverPhoto ? twicpicsSource(coverPhoto.url, 600, 600, -1) : null
  const color = (coverPhoto && coverPhoto.color) || DEFAULT_COLOR

  return (
    <div
      ref={coverPhotoAreaRef}
      className={`start-message-cover ${
        landingPage && !isCityOrWebcamActivity ? 'cover-photo-area' : 'start-message-without-cover-photo'
      }${isCityOrWebcamActivity ? ' is-city-or-webcam-activity' : ''}`}
    >
      {landingPage &&
        !isCityOrWebcamActivity &&
        (coverPhoto ? (
          <div
            className='inner-photo'
            style={{
              backgroundColor: color,
              backgroundImage: `url(${coverPhotoSrc})`,
              backgroundPosition: coverPhoto.pos
            }}
          />
        ) : (
          <div className='inner-photo no-image' style={{ backgroundColor: color }} />
        ))}
      {loadedImage && !isCityOrWebcamActivity && (
        <div className='inner-photo' style={{ backgroundImage: `url(${loadedImage})` }} />
      )}

      <div
        className={`${isCityOrWebcamActivity ? '' : 'inner-cover'}${
          landingPage && !isCityOrWebcamActivity && !coverPhoto ? ' color-only' : ''
        }`}
      >
        <div className='grid small-wide'>
          <div className='col-1-1'>
            <div className={`start-message${isCityOrWebcamActivity ? ' is-city-or-webcam-activity' : ''}`}>
              <h1>
                <BreakOnNewline text={h1} />
              </h1>
              <h2>
                <BreakOnNewline text={h2} />
              </h2>
            </div>
            {landingPage && landingPage !== 'webcam_subcategory' && !isCityOrWebcamActivity ? (
              <div className='form-block'>
                <div className='form-elements'>
                  <Searchbox withMagnifyingGlass searchCities={landingPage === 'category'} />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {isCityOrWebcamActivity && <How />}
    </div>
  )
}

export default StartMessage
